import React from "react";
import Icon from "@amzn/awsui-components-console/icon";
import Link from "@amzn/awsui-components-console/link";
import Container from "@amzn/awsui-components-console/container";
import Header from "@amzn/awsui-components-console/header";
import List from "@amzn/awsui-components-console/list";
import "../../styles/external-link-group.scss";

interface ExternalLinkItemProps {
  href: string;
  text: string;
}

interface ExternalLinkGroupProps {
  variant?: "default" | "container";
  header?: string;
  groupAriaLabel?: string;
  items: Array<ExternalLinkItemProps>;
}

const labelSuffix = "Opens in a new tab";

/**
 *
 * @param root0
 * @param root0.href
 * @param root0.text
 */
function ExternalLinkItem({ href, text }: ExternalLinkItemProps) {
  return (
    <Link href={href} ariaLabel={`${text} ${labelSuffix}`} target="_blank">
      <div className="custom-text__proper-case">{text}</div>
    </Link>
  );
}

/**
 *
 * @param root0
 * @param root0.header
 * @param root0.groupAriaLabel
 * @param root0.items
 * @param root0.variant
 */
export function ExternalLinkGroup({
  header = "Learn more",
  groupAriaLabel,
  items,
  variant = "default",
}: ExternalLinkGroupProps) {
  const externalIcon = (
    <span role="img" aria-label="Icon external Link">
      <Icon name="external" size="inherit" />
    </span>
  );

  if (variant === "container") {
    const headerId = "external-link-group-header";
    return (
      <Container
        header={
          <Header>
            <span id={headerId} className="custom-text__proper-case">
              {header} {externalIcon}
            </span>
          </Header>
        }
      >
        <List
          ariaLabelledby={headerId}
          disablePaddings
          items={items.map((item, index) => ({
            id: String(index),
            href: item.href,
            text: item.text,
          }))}
          renderItem={(item) => ({
            id: item.id,
            content: <ExternalLinkItem href={item.href} text={item.text} />,
          })}
        />
      </Container>
    );
  }

  return (
    <>
      <h3>
        {header} {externalIcon}
      </h3>
      <ul aria-label={groupAriaLabel}>
        {items.map((item, index) => (
          <li key={index}>
            <ExternalLinkItem href={item.href} text={item.text} />
          </li>
        ))}
      </ul>
    </>
  );
}
